import { exists } from '@/api'

export interface BatchTrcContentDetailRegisterCondition {
  startNumFrom: string
  startNumTo: string
  materialFormat: string
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  registeredContentDetailType: string
  registeredAuthorityType: string
  contentDetailTitleFile: string
  contentDetailDisplayAuthorFile: string
  memo: string
}

export function BatchTrcContentDetailRegisterConditionFromJSON(
  json: any
): BatchTrcContentDetailRegisterCondition {
  const _json = JSON.parse(json)

  return {
    startNumFrom: exists(_json, 'start_num_from') ? _json.start_num_from : '',
    startNumTo: exists(_json, 'start_num_to') ? _json.start_num_to : '',
    materialFormat: exists(_json, 'material_format')
      ? _json.material_format
      : '',
    convertHyoukiToFull: exists(_json, 'convert_hyouki_to_full')
      ? _json.convert_hyouki_to_full
      : false,
    convertKanaToHalf: exists(_json, 'convert_kana_to_half')
      ? _json.convert_kana_to_half
      : false,
    registeredContentDetailType: exists(_json, 'registered_content_detail_type')
      ? _json.registered_content_detail_type
      : '1',
    registeredAuthorityType: exists(_json, 'registered_authority_type')
      ? _json.registered_authority_type
      : '1',
    contentDetailTitleFile: exists(_json, 'content_detail_title_file')
      ? _json.content_detail_title_file
      : '',
    contentDetailDisplayAuthorFile: exists(
      _json,
      'content_detail_display_author_file'
    )
      ? _json.content_detail_display_author_file
      : '',
    memo: exists(_json, 'memo') ? _json.memo : ''
  }
}
